var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-cascader", {
    ref: "cascader",
    staticClass: "w100-percent",
    attrs: {
      props: _vm.cascaderProps,
      placeholder: "请选择区域",
      disabled: _vm.disabled,
    },
    on: { change: _vm.handleChange },
    model: {
      value: _vm.cascaderValue,
      callback: function ($$v) {
        _vm.cascaderValue = $$v
      },
      expression: "cascaderValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }